import React, { useEffect, useState } from "react";
import API from "../lib/api";

// Fetches a private media object via an AUTHENTICATED request (Authorization header +
// credentials), then renders it from a Blob URL. No token ever appears in a URL.
export function useBlob(path) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let alive = true;
    let objUrl;
    setUrl(null); setError(null);
    API.get(path, { responseType: "blob" })
      .then((r) => { objUrl = URL.createObjectURL(r.data); if (alive) setUrl(objUrl); })
      .catch((e) => { if (alive) setError(e); });
    return () => { alive = false; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path]);
  return { url, error };
}

export function AuthedImage({ path, className, alt = "" }) {
  const { url, error } = useBlob(path);
  if (error) return <div className={`${className} flex items-center justify-center bg-[#E8E4DB] text-[9px] text-[#8B3A3A]`}>error</div>;
  return url ? <img src={url} className={className} alt={alt} /> : <div className={`${className} animate-pulse bg-[#E8E4DB]`} />;
}

export function AuthedVideo({ path, className, testid }) {
  const { url, error } = useBlob(path);
  if (error) return <div className="text-xs text-[#8B3A3A]">Preview unavailable</div>;
  return url ? <video data-testid={testid} src={url} className={className} controls preload="metadata" /> : <div className={`${className} animate-pulse bg-black/10`} />;
}

export function AuthedFileLink({ path, className, children }) {
  const open = async () => {
    try {
      const r = await API.get(path, { responseType: "blob" });
      const u = URL.createObjectURL(r.data);
      window.open(u, "_blank");
      setTimeout(() => URL.revokeObjectURL(u), 60000);
    } catch { /* ignore */ }
  };
  return <button type="button" onClick={open} className={className}>{children}</button>;
}
